import { applyAppleTouchIcon } from './appleTouchIcon';

export const DEFAULT_DOCUMENT_TITLE = 'Salovare';
export const DEFAULT_DOCUMENT_DESCRIPTION =
  'Agenda, reservas online, assinaturas e folha de pagamentos para barbearias e salões. Comece grátis. Pro a partir de 9,90€/mês.';
const STORE_FAVICON_ATTRIBUTE = 'data-store-favicon';

const META_SELECTORS = {
  description: 'meta[name="description"]',
  ogTitle: 'meta[property="og:title"]',
  ogDescription: 'meta[property="og:description"]',
  ogUrl: 'meta[property="og:url"]',
  ogSiteName: 'meta[property="og:site_name"]',
  ogImage: 'meta[property="og:image"]',
  twitterTitle: 'meta[name="twitter:title"]',
  twitterDescription: 'meta[name="twitter:description"]',
  appleMobileWebAppTitle: 'meta[name="apple-mobile-web-app-title"]',
};

const upsertMeta = (selector, attributes, content) => {
  if (typeof document === 'undefined') return;

  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement('meta');
    Object.entries(attributes).forEach(([name, value]) => {
      element.setAttribute(name, value);
    });
    document.head.appendChild(element);
  }

  if (content) {
    element.setAttribute('content', content);
    return;
  }

  element.remove();
};

export const applyStoreFavicon = (faviconUrl) => {
  if (typeof document === 'undefined') return;

  const storeFavicon = document.head.querySelector(`link[${STORE_FAVICON_ATTRIBUTE}]`);
  if (!faviconUrl) {
    if (!storeFavicon) return;

    if (storeFavicon.dataset.storeFaviconCreated === 'true') {
      storeFavicon.remove();
    } else {
      storeFavicon.removeAttribute(STORE_FAVICON_ATTRIBUTE);
      storeFavicon.removeAttribute('data-store-favicon-created');
      storeFavicon.setAttribute(
        'href',
        storeFavicon.dataset.storeFaviconDefaultHref || '/favicon.ico',
      );
      delete storeFavicon.dataset.storeFaviconDefaultHref;
    }
    return;
  }

  const link = storeFavicon || document.head.querySelector('link[rel="icon"]') || document.createElement('link');
  if (!link.hasAttribute(STORE_FAVICON_ATTRIBUTE)) {
    const defaultHref = link.getAttribute('href');
    if (defaultHref) {
      link.dataset.storeFaviconDefaultHref = defaultHref;
    } else {
      link.dataset.storeFaviconCreated = 'true';
    }
  }
  link.setAttribute('rel', 'icon');
  link.setAttribute(STORE_FAVICON_ATTRIBUTE, 'true');
  link.setAttribute('href', faviconUrl);
  if (!link.parentNode) {
    document.head.appendChild(link);
  }
};

export const applyStoreDocumentMeta = ({
  title,
  appTitle,
  description,
  url,
  imageUrl,
  faviconUrl,
  iconVersion,
} = {}) => {
  if (typeof document === 'undefined') return;

  const nextTitle = (title && String(title).trim()) || DEFAULT_DOCUMENT_TITLE;
  const nextAppTitle = (appTitle && String(appTitle).trim()) || nextTitle;
  const nextDescription = (description && String(description).trim()) || nextTitle;

  document.title = nextTitle;
  upsertMeta(META_SELECTORS.description, { name: 'description' }, nextDescription);
  upsertMeta(META_SELECTORS.ogTitle, { property: 'og:title' }, nextTitle);
  upsertMeta(META_SELECTORS.ogDescription, { property: 'og:description' }, nextDescription);
  upsertMeta(META_SELECTORS.ogSiteName, { property: 'og:site_name' }, nextTitle);
  upsertMeta(META_SELECTORS.twitterTitle, { name: 'twitter:title' }, nextTitle);
  upsertMeta(META_SELECTORS.twitterDescription, { name: 'twitter:description' }, nextDescription);
  upsertMeta(META_SELECTORS.appleMobileWebAppTitle, { name: 'apple-mobile-web-app-title' }, nextAppTitle);
  upsertMeta(META_SELECTORS.ogUrl, { property: 'og:url' }, url || (typeof window !== 'undefined' ? window.location.href : ''));
  upsertMeta(META_SELECTORS.ogImage, { property: 'og:image' }, imageUrl);
  if (faviconUrl !== undefined) {
    applyStoreFavicon(faviconUrl);
  }

  if (iconVersion !== undefined) {
    applyAppleTouchIcon(iconVersion);
  }
};

export const resetDocumentMeta = () => {
  applyStoreDocumentMeta({
    title: DEFAULT_DOCUMENT_TITLE,
    description: DEFAULT_DOCUMENT_DESCRIPTION,
    url: typeof window !== 'undefined' ? `${window.location.origin}/` : '',
    imageUrl: typeof window !== 'undefined' ? `${window.location.origin}/logo192.png` : '',
    faviconUrl: '',
    iconVersion: '',
  });
};
